import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import {withEuroOrDash} from "../../../../../utils/utils";
import {ASSETS_LIABILITIES_CONFIG} from "../../../constants";

import styles from "./styles";

const CategoryHeader = ({classes, category, objectType, withTotal=true}) => {
  const assetTypeConfig = ASSETS_LIABILITIES_CONFIG[objectType];

  return (
    <Grid item xs={12} data-id={`${category.id}-headline`}>
      <Grid container spacing={1} alignItems={'center'}>
        <Grid item xs>
          <Grid container spacing={1} alignItems={'center'}>
            <Grid item className={classes.categoryName} data-id={'name'}>{category.title}</Grid>
            {!!objectType && (
              <Grid item className={classes.categoryItemsCount} data-id={'count'}>
                ({category.assets.length}<Box component={'span'} display={{ xs: 'none', sm: 'inline' }}> {category.assets.length === 1 ? assetTypeConfig.singleLabel : assetTypeConfig.pluralLabel}</Box>)
              </Grid>
            )}
          </Grid>
        </Grid>
        {withTotal && (
          <Grid item xs={'auto'}>
            <Grid container spacing={1} alignItems={'center'}>
              <Grid item className={classes.categoryTotal}>
                <Box display={{ xs: 'none', sm: 'block' }}>Gesamtwert</Box>
              </Grid>
              <Grid item><b>{withEuroOrDash(category.total_value)}</b></Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
};

export default withStyles(styles)(CategoryHeader);